export const MINI_NAV_POSITIONS = {
  HIDE: 'Hide',
  TOP: 'Top',
  BOTTOM_LEFT: 'Bottom-Left',
  BOTTOM_RIGHT: 'Bottom-Right',
};
